import React from "react";

const MotorSport = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      className={className}
    >
      <path d="M4.37525 3.32023C8.30324 1.42996 12.9005 1.57766 16.6998 3.71094C17.7958 4.32058 18.778 5.0922 19.6536 5.97499L8.96511 9.39649C8.05184 9.69217 7.43758 10.5411 7.43739 11.507V13.1635C7.43739 14.1955 8.15929 15.1045 9.15161 15.3248L23.9866 18.6469C23.8775 20.1591 22.7537 21.4107 21.2539 21.6111C16.6054 22.2268 12.1453 22.0794 7.20511 21.3943C4.47772 21.1428 2.15335 19.2947 1.2528 16.6844C-0.78828 12.2702 -0.719163 5.80044 4.37525 3.32023ZM20.595 7.02403C21.3326 7.94327 21.9678 8.95798 22.4566 10.0593C23.4943 12.4354 23.94 14.8464 24 17.3179L15.4546 15.4027L13.3015 9.36826L20.3549 7.11888L20.595 7.02403ZM13.9682 15.0707L9.42857 14.0567C9.02546 13.9613 8.72501 13.5885 8.72501 13.1635V11.507C8.72522 11.1084 8.98233 10.762 9.35933 10.6318L12.073 9.76122L13.9682 15.0707ZM10.9083 11.7994C10.5474 11.7996 10.254 12.0963 10.2538 12.4612C10.2538 12.8261 10.5474 13.1227 10.9083 13.1229C11.2693 13.1229 11.5627 12.8263 11.5627 12.4612C11.5626 12.0962 11.2693 11.7994 10.9083 11.7994Z" />
    </svg>
  );
};

export default MotorSport;
